import React from 'react';
import Hero from '../components/common/Hero';
import Button from '../components/common/Button';
import { caseStudiesHero, teamImage } from '../assets/images/imageImports';

const WhatWeBuild = () => {
  return (
    <div className="what-we-build-page">
      <Hero
        title="Case Studies"
        subtitle="Real results for our clients"
        buttonText="Contact Us"
        buttonLink="/contact"
        backgroundImage={caseStudiesHero}
      />
      
      <section className="section">
        <div className="container">
          <h2 className="section-title">Success Stories</h2>
          
          <div className="case-study">
            <div className="row">
              <div className="col-8">
                <h3>Fintech Company Achieves Clean Exit with ExitReady™</h3>
                <p className="case-study-meta">Industry: B2B FinTech | Size: $25M ARR | Outcome: Acquired at 6x revenue</p>
                <p>A founder-led SaaS company preparing for exit faced challenges with inconsistent financial data across their ERP, CRM, and other various operational systems. With an upcoming sale and LOI, they needed to reconcile key metrics and create a consistent financial story.</p>
                <h4>The Challenge:</h4>
                <ul>
                  <li>Manual reporting processes causing delays and errors</li>
                  <li>Lack of confidence in presenting financial data to buyers</li>
                  <li>Limited views of data</li>
                </ul>
                <h4>Our Solution:</h4>
                <p>SkySight implemented our ExitReady™ solution to create a centralized finance data warehouse that reconciled all key metrics across systems. We built automated reporting packages that aligned with typical buyer due diligence requests and created executive dashboards that clearly demonstrated the company's growth trajectory.</p>
                <h4>Results:</h4>
                <ul>
                  <li>Clean sale achieved, continuously updated data provided to the buy side advisors</li>
                  <li>Eliminated valuation discounting related to data quality concerns</li>
                  <li>Smooth transition of financial systems post-acquisition</li>
                </ul>
              </div>
              <div className="col-4">
                <div className="testimonial">
                  <p className="testimonial-text">"SkySight's ExitReady solution transformed our exit process. What would have been months of painful data reconciliation became a streamlined process that actually increased our valuation. The buyers specifically mentioned the quality of our financial data as a factor in their confidence."</p>
                  <p className="testimonial-author">— CEO, FinTech Company</p>
                </div>
              </div>
            </div>
          </div>
          
          <hr className="section-divider" />
          
          <div className="case-study">
            <div className="row">
              <div className="col-8">
                <h3>PE Portfolio Company Scales with ScalePath™</h3>
                <p className="case-study-meta">Industry: Healthcare Tech | Size: $40M Revenue | Outcome: 3x growth in 24 months</p>
                <p>A PE-backed healthcare technology company was struggling with outdated financial systems that couldn't scale with their aggressive growth targets. Manual processes were causing reporting delays, and leadership lacked real-time visibility into key performance metrics.</p>
                <h4>The Challenge:</h4>
                <ul>
                  <li>Legacy QuickBooks system unable to handle multi-entity structure</li>
                  <li>Excel-based reporting causing version control issues</li>
                  <li>No integrated view of financial and operational metrics</li>
                  <li>Month-end close taking 20+ days</li>
                </ul>
                <h4>Our Solution:</h4>
                <p>SkySight implemented our ScalePath™ program to modernize the company's finance and data infrastructure. We led the implementation of NetSuite for ERP, integrated with their existing systems, lead the implementation of Vena for FP&A, and built a comprehensive reporting package with Power BI dashboards for executive and board visibility.</p>
                <h4>Results:</h4>
                <ul>
                  <li>Reduced month-end close from 20+ days to 6 days</li>
                  <li>Created real-time visibility into key metrics for management</li>
                  <li>Supported 3x revenue growth without minimal headcount growth</li>
                  <li>Enabled data-driven decision making across departments</li>
                </ul>
              </div>
              <div className="col-4">
                <div className="testimonial">
                  <p className="testimonial-text">"The ScalePath program gave us the financial infrastructure we needed to grow confidently. We went from constantly fighting fires and questioning our numbers to having clear, reliable data that drives our decisions. It's been transformative for our business."</p>
                  <p className="testimonial-author">— CFO, Healthcare Tech Company</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="text-center" style={{marginTop: '3rem'}}>
            <div className="team-image-container">
              <img src={teamImage} alt="SkySight Analytics Team" className="team-image" />
            </div>
            <h3>Ready to transform your finance and data infrastructure?</h3>
            <p>Let's discuss how SkySight Analytics can help your business scale or prepare for exit.</p>
            <Button to="/contact" type="primary" size="large" style={{marginTop: '1rem'}}>Contact Us</Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhatWeBuild;